import StringHelper from './string';

export function subdomainUrl(subdomain, path = '/') {
  if (typeof path === 'undefined') {
    return `${window.location.protocol}//${subdomain}.${process.env.MIX_ROOT_DOMAIN}`;
  }

  path = StringHelper.leftTrim(path, '/');

  return `${window.location.protocol}//${subdomain}.${process.env.MIX_ROOT_DOMAIN}/${path}`;
}

export function url(path = '/') {
  if (typeof path === 'undefined') {
    return `${window.location.protocol}//${process.env.MIX_BASE_DOMAIN}`;
  }

  path = StringHelper.leftTrim(path, '/');

  return `${window.location.protocol}//${process.env.MIX_BASE_DOMAIN}/${path}`;
}
